import { WmsStockLotDto } from "src/dtos/wmsLot/wmsStockLotDto";
import { WmsTransportDetailDto, WmsTransportHeaderDto } from "src/dtos/wmsTransport/wmsTransportDto";
import { formatDate } from "src/utils/string/stringUtil";

export interface WMS2090_R01Dto {
	wmsTransportHeaderDto: WMS2090_R01HeaderDto;
	wmsTransportDetailDtoList: WMS2090_R01DetailDto[];
}

export interface WMS2090_R01HeaderDto extends WmsTransportHeaderDto {}

export const defaultWMS2090_R01HeaderDto: WMS2090_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	transportNo: '',
	compCd: '',
	compNm: '',
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	transportDt: '2026-01-01',
	inoutType: '',
	inoutClass: '100', // 입고구분값 100으로 고정(기초재고입고)
	customCd: '',
	customNm: '',
	otherLogicCenter: '',
	inoutMethod: '',
	empNo: '',
	empNm: '',
	transAmt: 0,
	vatAmt: 0,
	totalAmt: 0,
	telNo: '',
	faxNo: '',
	email: '',
	post: '',
	address: '',
	otherAddress: '',
	trackingNo: '',
	approveFlg: '',
	remark: '',

	inserted: false,
	isModified: false
}

// 입고 상세 DTO
export interface WMS2090_R01DetailDto extends WmsTransportDetailDto {
	// 재고테이블에 등록된 가용재고
	stockQty: number;
	// 기입고량, 여기서 기입고량을 입력하고 입고량을 업데이트 하고 백엔드에 전송
	updateTransportQty: number; 
	lotNo: string;
	printed: boolean; // 라벨 출력 여부
	/** 품목 보관위치(로케이션) - 라벨 storageLocation용 */
	locationCd?: string;
	locationNm?: string;
}


export const defaultWMS2090_R01DetailDto: WMS2090_R01DetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	transportNo: '',
	itemNo: '',
	compCd: '',
	compNm: '',
	logicCenter: '',
	transportDt: formatDate(new Date()),
	inoutType: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemStatus: '',
	unit: '',
	qty: 0,
	cost: 0,
	amt: 0,
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	remark: '',

	stockQty: 0,
	updateTransportQty: 0, // 기입고량, 여기서 기입고량을 입력하고 입고량을 업데이트 하고 백엔드에 전송
	lotNo: '',
	printed: false,
	locationCd: '',
	locationNm: '',
	
	inserted: false,
	isModified: false
}

export interface WMS2090_R01LotDto extends WmsStockLotDto {
	inputOutQty: number;
}

export const defaultWMS2090_R01LotDto: WMS2090_R01LotDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	warehouseCd: '',
	warehouseNm: '',
	lotNo: '',
	purchaseLotNo: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	itemStatus: '',
	lotQty: 0,
	transportNo: '',
	itemNo: '',
	remark: '',

	inputOutQty: 0,

	inserted: false,
	isModified: false,
}
